exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-user-settings-save-btn{width:100%;display:flex;justify-content:flex-end;align-items:center}\n", ""]);

// exports
